import React from 'react';
import Error from '../../pages/Error';

const NotFoundError = (): React.JSX.Element => {
    const notFoundMessages = [
        '404',
        "Something's missing...",
        'Not Found',
        'Well, this is awkward...',
    ];
    const reason = "We tried, but we couldn't find what you were looking for.";

    return <Error messages={notFoundMessages} defaultReason={reason} />;
};

export default NotFoundError;
